export const APP_STATUSES = "APP_STATUSES";

export default {
  APP_STATUSES,
};
